import React from 'react';
import { Link } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar, Typography, Menu, MenuItem} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
//import MenuIcon from '@material-ui/icons/Menu';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as IssueActions from "../actions/IssueActions";
import * as UserActions from "../actions/UserActions";
import { withRouter, NavLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
	navbarItem: {
    color: "white",
    marginRight: "10px",
    textDecoration: "none",
		fontSize: "14px",
		fontFamily: "Helvetica"
  },
  isActive: {
    color: "red"
  },
}));

const Header = (props) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          {/*<IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <MenuIcon />
          </IconButton>*/}
          <Typography variant="h6" className={classes.title}>
            <Link style={{color: "white", textDecoration: "none"}} to="/issue-tracker/">Issue Tracker</Link>
          </Typography>
					<NavLink className={classes.navbarItem} activeClassName={classes.isActive} to="/issue-tracker/about">
						ABOUT
					</NavLink>
					<NavLink className={classes.navbarItem} activeClassName={classes.isActive} to="/issue-tracker/issues">
						ISSUES
					</NavLink>
					<NavLink
            id="addIssue"
            onClick={() => {
              if (!props.users.isAuthenticated) {
                alert("You are not logged in hence redirecting to login page");
                //return <Redirect to="/" />
              }
            }} 
            className={classes.navbarItem}
            activeClassName={classes.isActive}
            to="/issue-tracker/addIssue"
          >
						ADD ISSUE
					</NavLink>
          {props.users.isAuthenticated && (
            <div id="userMenu">
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={open}
                onClose={handleClose}
              >
                <MenuItem 
                  onClick={() => {
                    handleClose();
                    props.history.push("/issue-tracker/profile");
                  }}
                >
                  {props.users.firstName}
                </MenuItem>
                <MenuItem 
                  onClick={() => {
                    handleClose();
                    props.userActions.logoutUser();
                  }}
                >
                  Logout
                </MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    issues: state.issues,
    users: state.users
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(IssueActions, dispatch),
    userActions: bindActionCreators(UserActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));